import { AnimatePresence, motion } from 'motion/react';
import React from 'react';

interface StepProps {
  [key: string]: any;
  variant: TransitionVariant;
  timeout?: number;
  nodeRef?: React.Ref<any>;
}

export enum TransitionVariant {
  Fade = 'fade',
  SlideLeft = 'slide-left',
  SlideRight = 'slide-right',
  Zoom = 'zoom',
  Toggle = 'toggle',
}

class StepTransition extends React.Component<StepProps> {
  private timeoutDefault = 300;

  constructor(props) {
    super(props);
    if (props.variant === TransitionVariant.Toggle) {
      this.timeoutDefault = 0;
    }
  }

  componentDidMount() {
    if (this.props.onEnter) {
      this.props.onEnter();
    }
    window.scrollTo(0, 0);
  }

  render() {
    const props = this.props;
    const initialScale = props.variant === TransitionVariant.Zoom ? 0.5 : 1;
    const initialPosition =
      props.variant === TransitionVariant.SlideLeft
        ? '100%'
        : props.variant === TransitionVariant.SlideRight
        ? '-100%'
        : 0;

    return (
      <AnimatePresence>
        <motion.div
          initial={{ opacity: 0, scale: initialScale, x: initialPosition }}
          animate={{ opacity: 1, scale: 1, x: 0 }}
          exit={{ opacity: 0 }}
          transition={{ opacity: 0.5 }}
        >
          {props.children}
        </motion.div>
      </AnimatePresence>
    );
  }
}

export default StepTransition;
